<template>
	<div>
		<table id="encuestas" class="table table-striped table-bordered" style="width:100%">
		    <thead>
		        <tr>
		            <th width="10px">Código</th>
		            <th>Pregunta</th>
		            <th width="120px">&nbsp;</th>
		        </tr>
		    </thead>
		</table>
	</div>
</template>
<script>
	export default {
		props: ['encuesta'],

		mounted(){
			this.index();
		},

		data() {
			return {
				oportunidades: []
			};
		},

		methods: {
			index(){
				var url = "/api/encuestasDetalle?encuesta="+this.encuesta;

				$(this.$el).children('#encuestas').DataTable({
					"order": [[ 0, "desc" ]],
					"processing": true,
                    "serverSide": true,
                    "ajax": url,
                    "select": true,
                    "dom": "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +"<'row'<'col-sm-12'tr>>" +"<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
                    "columns": [
                        {data: 'CODIGO_PREGUNTA'},
                        {data: 'PREGUNTA'},
                        {data: 'btn'},
                    ],
                    "columnDefs": [
			            /*{
			                "render": function (data, type, row) {
			                	return '<a href="'+ row['ver_cliente']+'" class="btn btn-link">'+data+'</a>';
			                },
			                "targets": 3,
			            },

			            {
			                "render": function (data, type, row) {
			                	return '<div v-tooltip="'+ row['DESCRIPCION_ETAPA']+'" class="progress" data-original-title="Recotizacion"><div role="progressbar" aria-valuenow="'+ row['PORCENTAJE_AVANCE'] +'" style="width: '+ row['PORCENTAJE_AVANCE'] +'%" aria-valuemin="0" aria-valuemax="100" class="progress-bar progress-bar-striped progress-bar-animated bg-primary"><small class="font-weight-bold">'+ row['PORCENTAJE_AVANCE'] +'%</small></div></div>';
			                },
			                "targets": 4,
			            },
						*/

			            {
			                "render": function (data, type, row) {
			                	return 'hola';
			                },
			                "targets": 2,
			            },
			        ],
                    "language": {
                        "info": "<b>Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros</b>",
                        "search": "Buscar",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "paginate": {
                            "next": "Siguiente",
                            "previous": "Anterior",
                        },
                        "lengthMenu": 'Mostrar <select2 >'+
                                    '<option value="10">10</option>'+
                                    '<option value="30">30</option>'+
                                    '<option value="-1">Todos</option>'+
                                    '</select2> registros',
                        "loadingRecords": "Cargando...",
                        "processing": '<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span>',
                        "emptyTable": "No se encontraron resultados",
                        "zeroRecords": "No hay coincidencias", 
                        "infoEmpty": "",
                        "infoFiltered": ""
                    }
                });
			}
		}
	}
</script>